if (!customElements.get('pewtner-navigation')) {
  customElements.define('pewtner-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const drawer = this.querySelector('.pw-navigation');
      const categories = Array.from(this.querySelectorAll('.pw-category'));
      const desktop = matchMedia('(min-width: 1200px)');
      const reset = () => {
        drawer.open = desktop.matches;
        categories.forEach(category => { category.open = false; });
      };
      reset();
      desktop.addEventListener('change', reset, options);
      categories.forEach(category => {
        category.addEventListener('toggle', () => {
          if (category.open) categories.forEach(other => { if (other !== category) other.open = false; });
        }, options);
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const active = categories.find(category => category.open);
        if (active) {
          active.open = false;
          active.querySelector('summary').focus();
        } else if (!desktop.matches && drawer.open) {
          drawer.open = false;
          drawer.querySelector('summary').focus();
        }
      }, options);
      document.addEventListener('click', event => {
        if (this.contains(event.target)) return;
        categories.forEach(category => { category.open = false; });
        if (!desktop.matches) drawer.open = false;
      }, options);
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) {
          categories.forEach(category => { category.open = false; });
          if (!desktop.matches) drawer.open = false;
        }
      }, options);
      window.addEventListener('pageshow', reset, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
